import React from 'react'
import { navigate } from 'gatsby'
import ChevronLeftIcon from '~/images/icons/chevron-left.svg'
import ChevronRightIcon from '~/images/icons/chevron-right.svg'

import {
    container,
    pagination_btn,
    chevron_icon
} from './styles'

type Props = {
    currentPageNumber: number
    numberOfPages: number
    nextPagePath: string
    previousPagePath: string
    pathName: string
}


const Pagination: React.VFC<Props> = ({ pathName, currentPageNumber, numberOfPages, nextPagePath, previousPagePath, ...props }) => {
    const pages = [...Array(numberOfPages).keys()]

    const PAGE_FIRST = 0
    const PAGINATION_LENGTH = 3
    const LATTER_HALF_LENGTH = 1
    const FIRST_HALF_LENGTH = 2

    let paginationStart
    let paginationEnd

    if(pages.length > PAGINATION_LENGTH){
        if(currentPageNumber === LATTER_HALF_LENGTH ){
            paginationStart = PAGE_FIRST
            paginationEnd = PAGINATION_LENGTH
        } else if(currentPageNumber === pages.length){
            paginationStart = pages.length - PAGINATION_LENGTH
            paginationEnd = pages.length
        } else {
            paginationStart = currentPageNumber - FIRST_HALF_LENGTH
            paginationEnd = currentPageNumber + LATTER_HALF_LENGTH
        }
    } else {
        paginationStart = PAGE_FIRST
    }

    return (
        <div css={container} {...props}>
            <button
                onClick={() => navigate(previousPagePath)}
                disabled={!previousPagePath}
                css={pagination_btn}
            >
                <img src={ChevronLeftIcon} alt='' css={chevron_icon} />
            </button>

            {pages.slice(paginationStart,paginationEnd).map(n => (
                <button
                    key={n}
                    onClick={() => navigate(n ? `${pathName}/${n + 1}` : `${pathName}/`)}
                    disabled={n + 1 === currentPageNumber}
                    css={pagination_btn}
                >
                    {n + 1}
                </button>
            ))}

            <button
                onClick={() => navigate(nextPagePath)}
                disabled={!nextPagePath}
                css={pagination_btn}
            >
                <img src={ChevronRightIcon} alt='' css={chevron_icon} />
            </button>
        </div>
    )
}

export default Pagination